import {
  type CancelDeviceModalFormSchema,
  CancellationTypeEnum,
} from './CancelDeviceModal.types'

export const cancelDeviceFormDefaultValues = (
  isScheduledCancellationEnabled: boolean,
  isScheduledCancellation: boolean,
  endAt: string | null,
): CancelDeviceModalFormSchema => {
  if (!isScheduledCancellationEnabled) {
    return {
      cancellationType: CancellationTypeEnum.IMMEDIATE,
      message: '',
      scheduledDate: null,
    }
  }

  if (isScheduledCancellation && endAt) {
    return {
      cancellationType: CancellationTypeEnum.SCHEDULED,
      message: '',
      scheduledDate: new Date(endAt),
    }
  }

  return {
    cancellationType: null,
    message: '',
    scheduledDate: null,
  }
}
